<h1 mat-dialog-title class="title content">{{ title }}</h1>

<div mat-dialog-content class="content">
    <mat-progress-spinner color="priamry" mode="indeterminate"></mat-progress-spinner>
    <br><br>
    <mat-label>{{label}}</mat-label>
</div>